import { Component } from '@angular/core';
import * as lightbox from 'lightbox2';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor() {
    lightbox.option({
      wrapAround: true,
      disableScrolling: true,
    });
  }
}
